import config from '../../config';
import { BaseRequestService } from './BaseRequest.service';
import { INewsService } from './types';

export class NewsService extends BaseRequestService implements INewsService {
  private static instance: NewsService;

  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    super();
  }

  static getInstance(): NewsService {
    this.instance ??= new NewsService();
    return this.instance;
  }

  protected getBaseUrl(): string {
    return config.news.url;
  }
}
